import Url from 'url';

/**
 *  Parses the URL *as seen by the browser*, and converts the query parameters into a set of
 *  nominally valid, normalized program options.
 *
 *  NB: This functions uses the browser's `window.location.href` URL as the source of program
 *  options. This may differ from the URL of the request as seen by the viz server, once nginx
 *  and others have rewritten, redirected, and reverse proxied the request from the browser to the
 *  viz server. Since running in local dev mode doesn't use nginx, you won't observe that
 *  behavior when running locally; however, this behavior is almost *always* happening when deployed
 *  to a server.
 *
 *  @param   {String}    href   The full URL from the browser.
 *
 *  @return  {Object}    An object with keys corresponding to each nominally valid, normalized
 *  parameter in the URL query string, with their corresponding values.
 */
export function getURLParameters(href) {
    const { query = {} } = Url.parse(href, true);
    const options = Object.keys(query).reduce((options, param) => {
        // Special-case normalization for certain params
        switch (param) {
            case 'datasetname':
                options.dataset = query.datasetname;
                break;
        }
        // Get raw value (handle array case)
        let rawVal = query[param];
        if (rawVal instanceof Array) {
            rawVal = rawVal[0];
        }
        // lowercase only for boolean/null checks, preserve original for storage
        const lowerVal = typeof rawVal === 'string' ? rawVal.toLowerCase() : rawVal;
        switch (lowerVal) {
            case 'null': return { ...options, [param]: null };
            case 'no': case 'false': return { ...options, [param]: false };
            case '': case 'yes': case 'true': return { ...options, [param]: true };
        }
        return { ...options, [param]: !isNaN(rawVal) ? +rawVal : rawVal };
    }, {});

    return { ...options, client: 'main' };
}
